import { render } from "./MyPlanItem.vue?vue&type=template&id=2ce13a5c&scoped=true"
import script from "./MyPlanItem.vue?vue&type=script&lang=js"
export * from "./MyPlanItem.vue?vue&type=script&lang=js"

import "./MyPlanItem.vue?vue&type=style&index=0&id=2ce13a5c&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce13a5c"]])

export default __exports__